// ########## Status ##########
export const REDPOINTS_SUBSCRIPTION_STATUS_PENDING = 'PENDING'
export const REDPOINTS_SUBSCRIPTION_STATUS_NO_MEMBER = 'NO_MEMBER'
export const REDPOINTS_SUBSCRIPTION_STATUS_SUBSCRIBED = 'SUBSCRIBED'
